import { supabase } from './api'
import { deleteScheduleIdData } from './scheduledays'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('sessionschedule').select()
	console.log('alllll', data)

	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('sessionschedule').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('sessionschedule').insert(adata).select()

	if (error) {
		console.log('error', error, adata)

		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('sessionschedule').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	await deleteScheduleIdData(id)
	const { data, error } = await supabase.from('sessionschedule').delete().eq('id', id)
	if (error) {
		console.log('Error', error)

		throw new Error('Failed to fetch data')
	}

	return data
}
